import { displayToPaise, parseCurrencyType, type CurrencyType } from '@/lib/currency'

export interface CreditTransferRequest {
  direction: 'give' | 'take'
  amount: string
  remark?: string
}

/** OpenAPI CreditTransferRequest — amount in INR paise (converted from node currency). */
export function toCreditTransferRequest(input: {
  direction: 'give' | 'take'
  amount: number
  remark?: string
  currencyType?: CurrencyType | string
}): CreditTransferRequest {
  const remark = input.remark?.trim()
  return {
    direction: input.direction,
    amount: displayToPaise(input.amount, parseCurrencyType(input.currencyType)),
    ...(remark ? { remark: remark.slice(0, 500) } : {}),
  }
}
